import { render, staticRenderFns } from "./DDMenu.vue?vue&type=template&id=0b600b75&"
import script from "./DDMenu.vue?vue&type=script&lang=ts&"
export * from "./DDMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports